import { SplitBRString } from "../helpers/dataHelper";
import { useGsap } from "../animations/hooks";

/**
 * Image + copy block used across the internal pages.
 * Props: img, title, description, imgPortrait, reverse, imgCircle, imgFlexible, className.
 *
 * On scroll the image slides in from its own side and the text from the
 * other (desktop); on narrow screens both rise into place instead so nothing
 * overflows horizontally.
 */
function ImageWithDescription(props) {
    const reverse = props?.reverse === true;

    const ref = useGsap((gsap, el) => {
        const media = el.querySelector(".iwd-media");
        const copy = el.querySelector(".iwd-copy");
        const mm = gsap.matchMedia();
        const build = (mediaFrom, copyFrom) => {
            gsap.timeline({ scrollTrigger: { trigger: el, once: true } })
                .from(media, { ...mediaFrom, autoAlpha: 0, duration: 0.9, clearProps: "transform" })
                .from(copy, { ...copyFrom, autoAlpha: 0, duration: 0.9, clearProps: "transform" }, "-=0.65");
        };
        mm.add("(min-width: 768px)", () => build({ x: reverse ? 48 : -48 }, { x: reverse ? -48 : 48 }));
        mm.add("(max-width: 767.98px)", () => build({ y: 32 }, { y: 32 }));
    }, [reverse]);

    const className = `img-with-description mt-4 ${props?.className ?? ""}`;
    const copy = (
        <span>{SplitBRString(props?.description)}</span>
    );

    if (props?.imgFlexible === true) {
        // suitable for both landscape and portrait images
        return (
            <div ref={ref} className={className}>
                <div className="row">
                    <div className={`col-md-5 col-xl-5 iwd-media${reverse ? " order-md-1" : ""}`}>
                        <div className="item">
                            <img src={props?.img} alt={props?.title} />
                        </div>
                    </div>
                    <div className="col-md-7 col-xl-7 iwd-copy">
                        <p className="align-items-center">
                        <h5 className="text-center"><strong>{props?.title}</strong></h5>
                        <br />
                        {copy}
                        </p>
                    </div>
                </div>
            </div>
        )
    }
    if (props?.imgCircle === true) {
        // our organization page
        return (
            <div ref={ref} className={className}>
                <div className="row">
                    <div className="col-12 col-sm-4 iwd-media">
                        <div className="text-center d-flex align-items-center justify-content-center img_container">
                            <img src={props?.img} alt={props?.title} className="mw-100" />
                        </div>
                    </div>
                    <div className="col-12 col-sm-8 d-flex align-items-center iwd-copy">
                        <p className="align-items-center">
                        <h5>{props?.title}</h5>
                        <br />
                        {copy}
                        </p>
                    </div>
                </div>
            </div>
        )
    }
    if (props?.imgPortrait == null) {
        // normal use landscape
        return (
            <div ref={ref} className={className}>
                <div className="row">
                    <div className={`col-md-5 col-xl-5 iwd-media${reverse ? " order-md-1" : ""}`}>
                        <div className="text-center d-flex align-items-center img_container">
                            <img src={props?.img} alt={props?.title} className="img_landscape" />
                        </div>
                    </div>
                    <div className="col-md-7 col-xl-7 iwd-copy">
                        <p className="align-items-center">
                        <h5 className="text-center"><strong>{props?.title}</strong></h5>
                        <br />
                        {copy}
                        </p>
                    </div>
                </div>
            </div>
        )
    }
    // normal use portrait
    return (
        <div ref={ref} className={className}>
            <div className="row">
                <div className={`col-md-4 col-xl-4 iwd-media${reverse ? " order-md-1" : ""}`}>
                    <div className="text-center d-flex align-items-center justify-content-center img_container">
                        <img src={props?.img} alt={props?.title} className="img_portrait" />
                    </div>
                </div>
                <div className="col-md-8 col-xl-8 d-flex align-items-center iwd-copy">
                    <p>
                    <h2 className="text-center p-0 mt-4">{props?.title}</h2>
                    <br />
                    {copy}
                    </p>
                </div>
            </div>
        </div>
    )
}
export default ImageWithDescription;
